<style lang="scss" scoped>
  .chart-component {
    .chart-funnel {
      width: 400px;
      height: 400px;
      text-align: center;
      margin: auto;
    }
  }
</style>

<template>
  <div
    class="chart-funnel"
    :style="{ height: height + 'px', width: width + 'px' }"
    ref="chart"
  />
</template>

<script>
export default {
  mounted () {
    this.$watch('fetched', () => this.generate(this.fetched));
  },

  props: {
    fetched: {},
    height: {
      default: 350,
    },
    width: {
      default: 350,
    },
  },

  data () {
    return {
      _chart: false,
      loading: false,
      defaults: {
        chart: {
          // bottomPinch: 1,
          curve: {
            enabled: true,
          },
          animate: 200,
        },
        block: {
          highlight: true,
        },
        label: {
          fontSize: '13px',
        },
      },
    };
  },

  methods: {
    generate (fetched) {
      if (this._chart) {
        this._chart.destroy();
      }

      setTimeout(() => {
        this._chart = new D3Funnel(this.$refs.chart);
        this._chart.draw(fetched.data.funnel, this.defaults);
      }, 300);
    },
  },
};
</script>
